import { Passenger } from '@app/models/micro/passenger.model';
import { Segment } from '@models/micro/segment.model';

import moment from 'moment';
import { FlightSummary } from '@models/micro/flight-summary.model';
import { Airports } from '@app/models';
import { WarningInt } from '@app/interfaces/micro/passengerListStandby.interface';
import { VENEZUELAN_BLOCK } from '@utils/constants/venezuelanBlock';
import { Reservation } from '@app/models/micro/reservation.model';
import { FARES_FAMILY, BagCommercialName } from '@app/enums';
import { SourceFlowCartType } from '@app/interfaces/micro/cart.interface';
import { RestrictedDestinations } from '@app/enums/restricted-destinations.enum';
import { CHECKIN_WINDOW } from '@app/utils/constants/generals';

const errorsReportStop: string[] = ['503'];

function validateCkiPax(passengers: Passenger[]) {
  return passengers.find((p) => p.checkinStatus);
}

function getAirLine(id) {
  const airlines = {
    ['AM']: {
      url: 'aeromexico.com',
      img: '../../../assets/images/airlines/AeromexicoNewLogo.png',
      txt: 'AeroMexico',
    },
    ['DL']: {
      url: 'delta.com',
      img: '../../../assets/images/airlines/Delta.png',
      txt: 'Delta',
    },
    ['AS']: {
      url: 'alaskaair.com',
      img: '../../../assets/images/airlines/Alaska Airlines.png',
      txt: 'Alaska Airlines',
    },
    ['AF']: {
      url: 'airfrance.com',
      img: '../../../assets/images/airlines/Airfrance.png',
      txt: 'Airfrance',
    },
    ['AR']: {
      url: 'www.aerolineas.com.ar',
      img: '../../../assets/images/airlines/Aerolineas Argentinas.png',
      txt: 'Aerolineas Argentinas',
    },
    ['UX']: {
      url: 'aireuropa.com',
      img: '../../../assets/images/airlines/AirEuropa.png',
      txt: 'AirEuropa',
    },
    ['CI']: {
      url: 'china-airlines.com',
      img: '../../../assets/images/airlines/China Airlines.png',
      txt: 'China Airlines',
    },
    ['MF']: {
      url: 'xiamenair.com',
      img: '../../../assets/images/airlines/Xiamen.png',
      txt: 'Xiamen Airlines',
    },
    ['MU']: {
      url: 'ceair.com',
      img: '../../../assets/images/airlines/China Eastern.png',
      txt: 'China Eastern Airlines',
    },
    ['OK']: {
      url: 'csa.cz',
      img: '../../../assets/images/airlines/Czchec airlines.png',
      txt: 'Czchec airlines',
    },
    ['GA']: {
      url: 'garuda-indonesia.com',
      img: '../../../assets/images/airlines/Garuda.png',
      txt: 'Garuda',
    },
    ['KE']: {
      url: 'koreanair.com',
      img: '../../../assets/images/airlines/Korean.png',
      txt: 'Korean Air Lines Co. Ltd.',
    },
    ['VS']: {
      url: 'flywith.virginatlantic.com',
      img: '../../../assets/images/airlines/Virgin.png',
      txt: 'Virgin Atlantic Airways Limited',
    },
    ['WS']: {
      url: 'westjet.com',
      img: '../../../assets/images/airlines/West jet.png',
      txt: 'WestJet',
    },
    ['VN']: {
      url: 'vietnamairlines.com',
      img: '../../../assets/images/airlines/Vietnam.png',
      txt: 'Vietnam Airlines',
    },
    ['SV']: {
      url: 'saudia.com',
      img: '../../../assets/images/airlines/Saudi.png',
      txt: 'Saudi Arabian Airlines Corp.',
    },
    ['RO']: {
      url: 'tarom.ro',
      img: '../../../assets/images/airlines/Tarom.png',
      txt: 'TAROM S.A.',
    },
    ['ME']: {
      url: 'mea.com',
      img: '../../../assets/images/airlines/MEA.png',
      txt: 'Middle East Airlines AirLiban',
    },
    ['KL']: {
      url: 'klm.com',
      img: '../../../assets/images/airlines/KLM.png',
      txt: 'Royal Dutch AirLines',
    },
    ['H5']: {
      url: 'cmairlines.com',
      img: '../../../assets/images/airlines/CM Airlines.png',
      txt: 'CM Airlines',
    },
    ['CZ']: {
      url: 'csair.com',
      img: '../../../assets/images/airlines/China Southern Airlines.png',
      txt: 'China Southern Airlines',
    },
    ['G3']: {
      url: 'voegol.com.br',
      img: '../../../assets/images/airlines/Avianca_Gool.png',
      txt: 'GOL Airlines',
    },
    ['LA']: {
      url: 'www.latamairlines.com',
      img: '../../../assets/images/airlines/LATAM Airlines Group.png',
      txt: 'LATAM Airlines',
    },
    ['IB']: {
      url: 'iberia.com',
      img: '../../../assets/images/airlines/Iberia.png',
      txt: 'Iberia Lineas Aereas de Espana',
    },
    ['KQ']: {
      url: 'kenya-airways.com',
      img: '../../../assets/images/airlines/Avianca_K.png',
      txt: 'Kenya Airways',
    },
    ['LR']: {
      url: 'avianca.com',
      img: '../../../assets/images/airlines/Avianca Costa Rica.png',
      txt: 'Avianca Costa Rica',
    },
    ['LX']: {
      url: 'swiss.com',
      img: '../../../assets/images/airlines/SWISS.png',
      txt: 'SWISS International Air Lines',
    },
    ['LY']: {
      url: 'elal.com',
      img: '../../../assets/images/airlines/EL AL.png',
      txt: 'El Al Israel Airlines',
    },
    ['PZ']: {
      url: 'latamairlines.com',
      img: '../../../assets/images/airlines/LATAM Airlines Paraguay.png',
      txt: 'LATAM Airlines Paraguay',
    },
    ['SK']: {
      url: 'flysas.com',
      img: '../../../assets/images/airlines/SAS.png',
      txt: 'Scandinavian Airlines',
    },
    ['TA']: {
      url: 'alternativeairlines.com',
      img: '../../../assets/images/airlines/TACA.png',
      txt: 'TACA International Airlines',
    },
    ['UA']: {
      url: 'united.com',
      img: '../../../assets/images/airlines/United Airlines.png',
      txt: 'United Airlines',
    },
    ['JL']: {
      url: 'jal.com',
      img: '../../../assets/images/airlines/Japan Airlines.png',
      txt: 'Japan Airlines',
    },
    ['AZ']: {
      url: 'issuu.com',
      img: '../../../assets/images/airlines/Alitalia.png',
      txt: 'Alitalia',
    },
    ['XL']: {
      url: 'latamairlines.com',
      img: '../../../assets/images/airlines/LATAM Airlines Ecuador.png',
      txt: 'Latam Airlines Ecuador',
    },
    ['LH']: {
      url: 'Lufthansa.com',
      img: '../../../assets/images/airlines/Lufthansa.png',
      txt: 'Lufthansa',
    },
    ['CX']: {
      url: 'cathaypacific.com',
      img: '../../../assets/images/airlines/Cathay Pacific.png',
      txt: 'Cathay Pacific Airways',
    },
  };
  return airlines[id] || '';
}

function getClosingMinutes(isDomestic: boolean): number {
  return isDomestic
    ? CHECKIN_WINDOW.DOMESTIC_CLOSING_MINUTES
    : CHECKIN_WINDOW.INTERNATIONAL_CLOSING_MINUTES;
}

function isClosed(flightSummaryParam: FlightSummary, activeSegment?: any) {
  const { isDomestic } = flightSummaryParam;

  const departure = activeSegment?.departureDateTime || flightSummaryParam.departureDateTime;

  const now = moment().local(true);
  const departureDateTimeMoment = moment(departure);

  const closingMinutes = getClosingMinutes(isDomestic);
  const dateEndValue = moment(departureDateTimeMoment).subtract(closingMinutes, 'minutes');

  return now.isBetween(dateEndValue, departureDateTimeMoment);
}

function isClosedWithDate(dateDeparture) {
  const now = moment().local(true);
  const dateMoment = moment(dateDeparture);

  return dateMoment.isSameOrBefore(now);
}

function truncateText(elementTXt, maxLength = '20') {
  let truncatedText = '';
  if (elementTXt?.length > maxLength) {
    truncatedText = elementTXt.slice(0, maxLength) + '...';
  } else {
    truncatedText = elementTXt;
  }
  return truncatedText;
}

function validateShowModalNoticeCanada(flightSummary, passengers = []) {
  let hasPaxCanada = true;
  let airport = Airports.findAriportByCode(flightSummary?.arrivalAirport);
  const airportCanada = airport && airport.country3 === 'CAN';
  const passagersLenght = passengers.length;
  const passagersFilter = passengers.filter((pax) => pax.checkinStatus).length;
  const hasCheckin = passagersLenght == passagersFilter;
  if (hasCheckin) {
    hasPaxCanada = findPaxMexInternationalDestinatination(passengers);
  }
  return airportCanada && hasPaxCanada && flightSummary.flightStatus !== 'FLOWN';
}

function validateShowModalNoticeGua(flightSummary, passengers = []) {
  let hasPaxCanada = true;
  let airport = Airports.findAriportByCode(flightSummary?.arrivalAirport);
  const airportCanada = airport && airport.country3 === 'GTM';
  const passagersLenght = passengers.length;
  const passagersFilter = passengers.filter((pax) => pax.checkinStatus).length;
  const hasCheckin = passagersLenght == passagersFilter;
  if (hasCheckin) {
    hasPaxCanada = findPaxMexInternationalDestinatination(passengers);
  }
  return airportCanada && hasPaxCanada && flightSummary.flightStatus !== 'FLOWN';
}

function findPaxMexInternationalDestinatination(passengers: Passenger[]) {
  return !!passengers.find((pax) => pax?.passport?.nationality === 'MX');
}

/**
 * Resultado de evaluar la regla de despliegue del modal FEM (CI-22888).
 * `reason` permite registrar en New Relic por qué se mostró u omitió el modal.
 */
export interface FemEvaluation {
  show: boolean;
  reason:
    | 'eligible'
    | 'no_flight_data'
    | 'domestic'
    | 'origin_not_mexico'
    | 'destination_not_international'
    | 'not_mexican';
  nationalityMatched: boolean;
  originStation: string;
  destinationStation: string;
  flightType: 'international' | 'domestic';
}

const MEXICO_COUNTRY_CODE = 'MEX';

/** País del aeropuerto: usa el campo del segmento y cae al catálogo de Airports (country3). */
function getSegmentCountry(airportCode: string, segmentCountry?: string): string {
  if (segmentCountry) {
    return segmentCountry;
  }
  return Airports.findAriportByCode(airportCode)?.country3 ?? '';
}

/**
 * CI-22888: el modal FEM solo se muestra para pasajeros mexicanos en vuelos
 * internacionales que originan en México hacia un destino internacional.
 * En conexiones se evalúa el origen del primer tramo y el destino del último.
 */
function validateShowFEMModal(
  flightSummary: FlightSummary,
  passengers: Passenger[] = []
): FemEvaluation {
  const nationalityMatched = passengers.some(
    (pax) => pax?.passengerInfo?.passport?.nationality === MEXICO_COUNTRY_CODE
  );

  if (!flightSummary) {
    return {
      show: false,
      reason: 'no_flight_data',
      nationalityMatched,
      originStation: '',
      destinationStation: '',
      flightType: 'domestic',
    };
  }

  const segments = [...(flightSummary.segments ?? [])].sort(
    (a, b) => (a?.sequence ?? 0) - (b?.sequence ?? 0)
  );
  const firstSegment = segments[0];
  const lastSegment = segments[segments.length - 1];

  const originStation = firstSegment?.departureAirport ?? flightSummary.departureAirport ?? '';
  const destinationStation = lastSegment?.arrivalAirport ?? flightSummary.arrivalAirport ?? '';
  const flightType: 'international' | 'domestic' = flightSummary.isDomestic
    ? 'domestic'
    : 'international';

  const base = { nationalityMatched, originStation, destinationStation, flightType };

  if (flightSummary.isDomestic) {
    return { show: false, reason: 'domestic', ...base };
  }

  const originCountry = getSegmentCountry(originStation, firstSegment?.departureCountry);
  if (originCountry !== MEXICO_COUNTRY_CODE) {
    return { show: false, reason: 'origin_not_mexico', ...base };
  }

  const destinationCountry = getSegmentCountry(destinationStation, lastSegment?.arrivalCountry);
  if (destinationCountry === MEXICO_COUNTRY_CODE) {
    return { show: false, reason: 'destination_not_international', ...base };
  }

  if (!nationalityMatched) {
    return { show: false, reason: 'not_mexican', ...base };
  }

  return { show: true, reason: 'eligible', ...base };
}

/**
 * CI-22888: decide si mostrar el modal FEM combinando el flag de kiosk-profile
 * con la evaluación de reglas. Devuelve también la evaluación para la métrica.
 */
function evaluateFemModal(
  flightSummary: FlightSummary,
  passengers: Passenger[] = [],
  femFlagEnabled = false
): { show: boolean; evaluation: FemEvaluation } {
  const evaluation = validateShowFEMModal(flightSummary, passengers);
  return { show: femFlagEnabled && evaluation.show, evaluation };
}

/** CI-22888: arma los atributos de la métrica New Relic de la evaluación FEM. */
function buildFemMetricPayload(
  show: boolean,
  evaluation: FemEvaluation,
  femFlagEnabled: boolean,
  passengers: Passenger[] = []
): Record<string, string> {
  const mexicanPassengerIds = passengers
    .filter((pax) => pax?.passengerInfo?.passport?.nationality === MEXICO_COUNTRY_CODE)
    .map((pax) => pax?.passengerId ?? pax?.nameRefNumber ?? '')
    .filter((id) => !!id);

  return {
    result: show ? 'desplegado' : 'omitido',
    reason: femFlagEnabled ? evaluation.reason : 'flag_disabled',
    nacionalidad: evaluation.nationalityMatched ? 'MEX' : 'otra',
    estacion_origen: evaluation.originStation,
    estacion_destino: evaluation.destinationStation,
    tipo_vuelo: evaluation.flightType,
    passengerId: mexicanPassengerIds.join(','),
  };
}

function getWarnigsReport(warnings: WarningInt[] = []) {
  return warnings.some((warning) => errorsReportStop.includes(warning.code));
}

// CI-23791: patron compartido para detectar el warning UK-UPT (estatus
// migratorio UK pendiente). Vive aqui (no en UkUptGuardService) para que
// tambien lo use ApiMapper.validateCheckin, un contexto estatico sin
// Angular DI — una sola fuente de verdad para el patron en ambos lugares.
const UK_UPT_PATTERN = /UK[-\s]?UPT/i;

function hasUkUptWarning(warnings: WarningInt[] | null | undefined): boolean {
  return (warnings ?? []).some((w) =>
    UK_UPT_PATTERN.test(`${w?.code ?? ''} ${w?.errorMessage ?? ''}`)
  );
}

export function validateVenezuelan(
  passengers: Passenger[],
  segments: Segment[],
  flightSummaryParam: FlightSummary
) {
  if (!flightSummaryParam.isDomestic) {
    const venezuelans = passengers.filter(
      (el) => el.passengerInfo?.passport?.nationality === 'VEN'
    );
    const isCountryBlock = !!segments.find((segment) =>
      VENEZUELAN_BLOCK.includes(segment.arrivalCountry)
    );
    return {
      success: venezuelans?.length > 0 && isCountryBlock,
      passengers: venezuelans,
    };
  } else {
    return {
      success: false,
      passengers: [],
    };
  }
}

function isHavanaFlight(segments: Segment[]): boolean {
  if (!segments || segments.length === 0) return false;
  return segments.some((segment) => segment.arrivalAirport === RestrictedDestinations.HAVANA);
}

function boardingTime(departureDateTime, isDomestic) {
  const closingMinutes = getClosingMinutes(isDomestic);
  return moment(departureDateTime).subtract(closingMinutes, 'minutes');
}

function getTypeFlowIrops(leg: Reservation): 'commercial' | 'operational' | null {
  const segments = leg.flightSummary?.segments.filter(
    (segment) => segment.windowSegmentStatus !== 'CLOSED'
  );
  const oldSegments =
    leg.oldFlightSummary?.segments?.filter((segment) => segment.windowSegmentStatus !== 'CLOSED') ??
    [];
  let [segment] = segments;
  const [oldSegment] = oldSegments;
  const now = moment();

  // Si no hay segmentos abiertos, buscar segmentos con reserva activa (posible demora)
  if (!segment) {
    const closedSegments = leg.flightSummary?.segments.filter(
      (segment) => segment.segmentStatusCode === 'HK' || segment.segmentStatusCode === 'MM'
    );
    if (!closedSegments?.length) return null;
    segment = closedSegments[0];
  }

  const departureTime = moment(segment.departureDateTime);
  const hoursDiff = departureTime.diff(now, 'hours');

  // CI-21913: SC/WK/EXCH siempre se maneja como commercial (confirmación directa a HK)
  // sin importar la ventana temporal. La distinción de 72h aplica para demoras operativas.
  if (
    segment.segmentStatusCode.includes('WK') ||
    segment?.segmentStatusCode?.includes('SC') ||
    segment?.segmentStatusCode?.includes('EXCH')
  ) {
    segment.isCancelOag = true;
    return 'commercial';
  }

  if (hoursDiff > 72) {
    // Estamos en ventana comercial
    if (segment.segmentStatusCode.includes('WK') && oldSegment?.segmentStatusCode?.includes('SC')) {
      //Adelantados o demorados
      return 'commercial';
    } else {
      if (
        segment.segmentStatusCode.includes('WK') ||
        segment?.segmentStatusCode?.includes('SC') ||
        segment?.segmentStatusCode?.includes('EXCH')
      ) {
        segment.isCancelOag = true;
        return 'commercial';
      } else {
        return null;
      }
    }
  } else if (hoursDiff <= 72) {
    // Estamos en ventana operativa - flightstats valida si hay demora real
    return 'operational';
  }

  // No aplica
  return null;
}

function generatePhoneMask(length: number): string {
  length = Math.min(Math.max(length, 8), 14); //Se asegura de que el valor de length esté entre 8 y 14.
  const groups: number[] = [];
  let remaining = length; //La variable remaining guarda cuántos dígitos faltan por distribuir en los grupos.

  while (remaining > 4) {
    groups.push(3);
    remaining -= 3;
  }
  groups.push(remaining);

  return groups.map((groupLen) => '0'.repeat(groupLen)).join(' '); //Se transforma cada número del arreglo groups en una cadena de ceros del mismo tamañ,Luego, se unen esas cadenas con espacios.
}

function getOnlyDigits(value: string): string {
  return value.replace(/\D/g, '');
}

function isClosedMYB(flightSummaryParam: FlightSummary, activeSegment?: any) {
  const { isDomestic } = flightSummaryParam;

  const departure = activeSegment?.departureDateTime || flightSummaryParam.departureDateTime;

  const now = moment().local(true);
  const departureDateTimeMoment = moment(departure);

  const maxMinutesBeforeDeparture: number = isDomestic ? 2880 : 1440;
  const diff = moment.duration(departureDateTimeMoment.diff(now));
  const minutes = diff.asMinutes();
  return {
    status: minutes > maxMinutesBeforeDeparture,
    h: minutes,
    diff: maxMinutesBeforeDeparture,
    data: diff,
  };
}

function isRouteCarryOn(summary) {
  const routes = ['BJX_MEX', 'MEX_PXM', 'CPE_MEX', 'MEX_SLP', 'BJX_PXM', 'CPE_SLP'];

  return routes.includes(summary?.legCode.substring(0, 7));
}

function showCarryon(reservation: Reservation, admin) {
  const { flightSummary, creationDate } = reservation;
  const { fareFamily, legRegion } = flightSummary;
  const { INTERNATIONALROUTES } = admin;

  return (
    INTERNATIONALROUTES &&
    legRegion != 'USA' &&
    (fareFamily === FARES_FAMILY.MAIN_LIGHT ||
      fareFamily === FARES_FAMILY.MAIN_BASIC ||
      fareFamily === FARES_FAMILY.AMPLUS_BASIC ||
      fareFamily === FARES_FAMILY.PREMIER_BASIC) &&
    // isRouteCarryOn(flightSummary) &&   /// se comenta porque es para todas las rutas que sean basicas o la nueva tarifa
    reservation.isNewBF
  ); /// se deja en false porque no llega la bandera en el pnr
}

function convertFormatToHoursMinutes(formatDate: string) {
  const hoursMatch = formatDate.match(/(\d+)\s*h/);
  const minutesMatch = formatDate.match(/(\d+)\s*m/);

  const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
  const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;

  return hours * 60 + minutes;
}

function orderByTotalTimeFlight(flights: any) {
  return flights.sort((a, b) => {
    const timeA = convertFormatToHoursMinutes(a.totalFlightTimeFormatHM);
    const timeB = convertFormatToHoursMinutes(b.totalFlightTimeFormatHM);
    return timeA - timeB;
  });
}

function parseDateFlight(reservation: any, counterChooseFlight: number): string {
  const departureDate = reservation.flightSummary.currentSegment.departureDateTime.split('T')[0];
  const momentFromJsDate = moment(departureDate).add(counterChooseFlight, 'days');
  const formattedDate = momentFromJsDate.format('YYYY-MM-DD');
  console.log(formattedDate);
  return formattedDate;
}

function getEffectiveDepartureTime(segment: any): string {
  if (segment?.flightsNewInfo?.departureDateTime) {
    return segment.flightsNewInfo.departureDateTime;
  }
  if (segment?.estimatedDepartureTime) {
    return segment.estimatedDepartureTime;
  }
  return segment?.departureDateTime || '';
}

function hasCarryOn15kg(cart: any): boolean {
  const carryOnItem = cart?.items?.find(
    (item) => item.typeAncillarie === SourceFlowCartType.CARRY_ON
  );
  return (
    carryOnItem?.detail?.[0]?.bagStackCarryon?.some(
      (bag) => bag.commercialName === BagCommercialName.CARRY_ON_15KG
    ) ?? false
  );
}

function validationAddOn5kg(reservation: Reservation, cart: any): boolean {
  const { fareFamily } = reservation.flightSummary;
  const isBasicFare = [
    FARES_FAMILY.MAIN_BASIC,
    FARES_FAMILY.AMPLUS_BASIC,
    FARES_FAMILY.PREMIER_BASIC,
  ].includes(fareFamily);

  return isBasicFare && hasCarryOn15kg(cart);
}

/**
 * Verifica si el vuelo ya despegó basándose en la hora recalculada (PNR + diff de flightstats).
 * Si el currentSegment tiene flightsNewInfo.departureDateTime y esa hora ya pasó, el vuelo ya se fue.
 */
function isFlightAlreadyDeparted(reservation: Reservation): boolean {
  const boardingStatus = ['IN_FLIGHT', 'CLOSED']; //NUEVO
  const currentSegment = reservation.flightSummary?.currentSegment;

  if (currentSegment?.flightsNewInfo?.departureDateTime) {
    const estimatedDeparture = moment(currentSegment?.flightsNewInfo?.departureDateTime);
    return moment().isAfter(estimatedDeparture);
  } else if (boardingStatus.includes(currentSegment?.windowSegmentStatus)) {
    //NUEVO
    return true;
  }
  return false;
}

export {
  generatePhoneMask,
  getOnlyDigits,
  truncateText,
  validateCkiPax,
  getAirLine,
  getClosingMinutes,
  isClosed,
  isClosedWithDate,
  validateShowModalNoticeCanada,
  validateShowModalNoticeGua,
  validateShowFEMModal,
  evaluateFemModal,
  buildFemMetricPayload,
  getWarnigsReport,
  hasUkUptWarning,
  UK_UPT_PATTERN,
  getTypeFlowIrops,
  isHavanaFlight,
  boardingTime,
  showCarryon,
  convertFormatToHoursMinutes,
  orderByTotalTimeFlight,
  isClosedMYB,
  parseDateFlight,
  getEffectiveDepartureTime,
  hasCarryOn15kg,
  validationAddOn5kg,
  isFlightAlreadyDeparted,
};
